import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { userAPI } from '../../services/api';
import CheckInSection from '../../components/CheckInSection/CheckInSection';
import styles from './Checkin.module.css';

const Checkin = () => {
  const { isAuthenticated } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // 获取用户资料信息
  const fetchUserProfile = useCallback(async () => {
    if (!isAuthenticated()) return;

    try {
      const response = await userAPI.getProfile();
      setUserProfile(response.data.data);
    } catch (error) {
      console.error('Failed to fetch user profile:', error);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated()) {
      fetchUserProfile();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, fetchUserProfile]);

  const handleCheckInSuccess = (reward) => {
    // 更新用户资料中的金币余额
    if (userProfile) {
      setUserProfile(prev => ({
        ...prev,
        coinBalance: (prev.coinBalance || 0) + reward.coins,
        checkInStreak: (prev.checkInStreak || 0) + 1,
        totalCheckIns: (prev.totalCheckIns || 0) + 1,
        lastCheckIn: new Date().toISOString()
      }));
    }
  };

  if (!isAuthenticated()) {
    return (
      <div className={styles.container}>
        <div className={styles.authPrompt}>
          <h2>请先登录</h2>
          <p>您需要登录后才能使用签到功能</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <p>加载中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {userProfile && (
        <CheckInSection
          userProfile={userProfile}
          onCheckInSuccess={handleCheckInSuccess}
        />
      )}
    </div>
  );
};

export default Checkin;